import ng from "angular";

@Controller('ib-MmB-gastronomic-proposal-module', ['$uibModalInstance'], [])
export class IbPreSelectionModalController implements ng.IController {

    currentStep = 'menu_options';

    constructor(private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,) { }

    active = (): any => {
    };

    close() {
        this.$uibModalInstance.close();
    }

    changeComponent() {
        this.currentStep = this.currentStep === 'menu_options' ? 'summary_selection' : 'menu_options';
    }

    $onInit = this.active();
}
